import { render, staticRenderFns } from "./RemovePaymentModal.vue?vue&type=template&id=606b5151&"
import script from "./RemovePaymentModal.vue?vue&type=script&lang=js&"
export * from "./RemovePaymentModal.vue?vue&type=script&lang=js&"
import style0 from "./RemovePaymentModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports